import { render, staticRenderFns } from "./Karin-type-form.vue?vue&type=template&id=39c8c460"
import script from "./Karin-type-form.vue?vue&type=script&lang=js"
export * from "./Karin-type-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports